import { ShareRequestStatuses } from "@/components/constants.js"

export default [
  {
    value: "createdAt",
    text: "Created At",
    width: 150,
    sortable: true,
  },
  {
    value: "shareeEmail",
    text: "Sharee Email",
    width: 190,
    sortable: true,
  },
  {
    value: "camera",
    text: "Camera",
    width: 200,
    sortable: true,
  },
  {
    value: "sharer",
    text: "Sharer",
    width: 150,
    sortable: true,
  },
  {
    value: "rights",
    text: "Rights",
    width: 80,
    align: "center",
    sortable: true,
  },
  {
    value: "status",
    text: "Status",
    width: 80,
    sortable: true,
    toStringFn: (item, key) =>
      ShareRequestStatuses.find((el) => el.value === item[key])?.name,
  },
  {
    value: "message",
    text: "Message",
    width: 400,
    sortable: true,
  },
]
